import React from "react";
import About from "../../public/about/About";
import MenuHospital from "../navHospital/MenuHospital";

function AboutHospital() {
    return (
        <div>
            <MenuHospital/>
            <About disabledMenu />
        </div>
    )
}
export default AboutHospital